export default __webpack_public_path__ + "static/media/bio2.f8438135.jpg";